﻿export enum ScopeSelectorSelectionMode {
    Single = 'single',
    Multi = 'multi'
}

export type Scope = {
    identity: string;
    description: string;
};

export function compareByIdentity(a: Scope, b: Scope): number {
    return a.identity.localeCompare(b.identity);
}

export function compareByIsInSet(a: Scope, b: Scope, referenceSet: Set<string>): number {
    const aInSet = referenceSet.has(a.identity);
    const bInSet = referenceSet.has(b.identity);

    if (aInSet && !bInSet) {
        return -1;
    } else if (!aInSet && bInSet) {
        return 1;
    } else {
        return 0;
    }
}
